import { fabric } from 'fabric';
import Vec2 from 'vec2';

import { drawingTool } from '../../drawingTool';
import { getClipCircle } from './getClipCircle';

import { DrawingShape } from '~/core/models';
import { createClipPolygon } from '~/core/utils';
import theme from '~/theme/theme';

const {
  drawingTool: { secondaryBorderColor },
} = theme.light;

export type ClipShapeListType = fabric.Path | fabric.Circle | fabric.Polygon;

export const getBoneOutline = (
  drawingShape: DrawingShape,
  clipShapeList: ClipShapeListType[],
  useOverlay: boolean,
  i: number
) => {
  const boneOutline = drawingTool.getOutlinePointsFromCorners(
    [...Object.values(drawingShape.cornerMap)],
    i
  );

  if (!boneOutline) {
    return;
  }

  const clipBoneOutline = [];

  // next three lines do nothing but allow clipBoneOutline to work within the loop and outside
  // any ideas on how to remove this, great
  const noPoint = new Vec2(0, 0);

  clipBoneOutline.push(noPoint);
  clipBoneOutline.pop();

  boneOutline.forEach((outlinePt) => {
    const r = outlinePt.size;

    if (
      ((r && r > 0.75) || outlinePt.diagonalLength) &&
      outlinePt.isVisibleInCanvas
    ) {
      clipBoneOutline.push(outlinePt.replacementStartCoords);
      clipBoneOutline.push(outlinePt.replacementEndCoords);
      if (
        outlinePt.angle &&
        outlinePt.angle > 0 &&
        outlinePt.orientationAngle !== undefined &&
        outlinePt.radiusCenterPoint &&
        !outlinePt.diagonalLength
      ) {
        // also add an internal circle to the clipping area for external corners
        const clipCircle = getClipCircle(outlinePt, useOverlay, r);

        clipShapeList.push(clipCircle); // comment this line to see only clip polygons
      }
    } else {
      // just a normal corner, nothing to see here
      clipBoneOutline.push(outlinePt.coords);
    }
  });

  const clipPoly = createClipPolygon(
    clipBoneOutline,
    useOverlay,
    secondaryBorderColor
  );

  clipShapeList.push(clipPoly);
};
